import { Box, Chip } from "@mui/material";
import pluralize from "pluralize";
import useColors from "../../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../../components/CustomTooltip";
import iconMapping from "../../../../../../icons/IconMapping";
import { getEntityTypeDisplayName } from "../../../../../../utils/utils";

const createLabel = (entityType, quantity) => {
  const type = pluralize(getEntityTypeDisplayName(entityType));
  return `${type} (${quantity})`;
};

const EntitiesChip = ({ entityType, quantity, onClick }) => {
  const colors = useColors();
  const label = createLabel(entityType, quantity);

  let Icon = iconMapping[entityType] || iconMapping["Internet"];

  return (
    <CustomTooltip title="View details" placement="top">
      <Chip
        label={label}
        onClick={onClick}
        icon={
          <Icon
            style={{
              color: colors.text_primary,
              width: "20px",
              height: "20px",
            }}
          />
        }
        style={{
          background: colors.entity_chip_enabled_fill,
          borderRadius: "8px",
          fontSize: "12px",
          color: colors.text_primary,
          boxShadow: colors.entity_chip_enabled_shadow,
          height: "32px",
          paddingLeft: "4px",
        }}
        sx={{
          "& .MuiTouchRipple-root": { display: "none !important" },
        }}
      />
    </CustomTooltip>
  );
};

const EntitiesChipList = ({ entitiesByType, handleChipClick }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      maxWidth="600px"
      height="32px"
      overflow="hidden"
      flexWrap="wrap"
    >
      {Object.entries(entitiesByType)
        .sort(([, a], [, b]) => b.length - a.length)
        .map(([entityType, entities]) => (
          <EntitiesChip
            key={entityType}
            entityType={entityType}
            quantity={entities.length}
            onClick={() => {
              handleChipClick(entityType);
            }}
          />
        ))}
    </Box>
  );
};

export default EntitiesChipList;
